<template>
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
        <v-card>
            <div class="card-section-header px-6 py-4">
                <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                        <v-icon class="mr-2" color="white" size="18">mdi-email-outline</v-icon>
                        <span class="card-section-title">Preview Quote Email</span>
                    </div>
                    <v-btn icon small @click="closeDialog()">
                        <v-icon color="white">mdi-close</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-card-text class="pa-0" style="max-height: 900px;">
                <div v-if="!hasRequiredData" class="pa-8 text-center">
                    <v-progress-circular indeterminate color="#3988AA"></v-progress-circular>
                    <div class="mt-4">Loading preview...</div>
                </div>
                <div class="email-preview-container" v-else>
                    <!-- Email Preview -->
                    <div class="email-content">
                        <div style="text-align:center;">
                            <img src="https://storage.googleapis.com/gogroupbooking/quote_email_header.jpg"
                                style="width:100%;height:auto;object-fit:cover;">
                        </div>
                        <div class="first-paragraph">
                            <div style="text-align:center;font-size:32px;color:black;"><b>Hello {{ (lead &&
                                lead.first_name) || 'there' }},</b></div>
                            <br>
                            <v-textarea v-model="customMessage" auto-grow rows="6" outlined hide-details
                                placeholder="Enter a custom message for this quote..."
                                style="font-size:20px;color:black;max-width:600px;margin:0 auto;"
                                @input="onCustomMessageChange"></v-textarea>
                        </div>
                        <div style="background-color:#000001;padding:20px;text-align:center;">
                            <div style="display:inline-flex;flex-wrap:wrap;margin-bottom:25px;">
                                <div style="display:flex;margin-right:40px;">
                                    <div><img src="https://storage.googleapis.com/gogroupbooking/date.png"></div>
                                    <div style="margin-left:10px;text-align:left;">
                                        <div style="color:#FAAF3A;font-size:14px;font-weight:800;">EVENT DATE</div>
                                        <div style="color:white;font-size:18px;font-weight:600;">
                                            {{ (lead && $date(lead.start_date).format('DD/MM/YYYY')) || 'TBD' }} - {{
                                                (lead && $date(lead.end_date).format('DD/MM/YYYY')) || 'TBD' }}
                                        </div>
                                    </div>
                                </div>
                                <div style="display:flex;">
                                    <div><img src="https://storage.googleapis.com/gogroupbooking/ticket.png"></div>
                                    <div style="margin-left:10px;text-align:left;">
                                        <div style="color:#FAAF3A;font-size:14px;font-weight:800;">EVENT DETAILS</div>
                                        <div style="color:white;font-size:18px;font-weight:600;">
                                            {{ (quote && quote.name) || 'Event Quote' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style="background-color:#FFFFFE;padding:10px;">
                            <div style="border:solid 1px black;border-radius:20px;padding:20px;">
                                <div style="font-size:32px;font-weight:700;color:black;text-align:center;">Secure Your
                                    Booking</div>
                                <br>
                                <div style="font-size:16px;color:#7C7C7C;text-align:center;">
                                    Final group numbers and full payment is NOT required until {{ balanceDue }} before you go.
                                    <br>
                                    We only require one person's payment as a deposit to secure your booking.
                                </div>
                                <br>
                                <div style="text-align:center;margin-top:10px;">
                                    <div style="font-size:40px;color:#7C7C7C;font-weight:600;">
                                        <label style="font-size:16px;color:#7C7C7C;">{{ (company && company.currency) ||
                                            '€' }}</label>
                                        <label style="text-decoration:line-through;margin-right:15px;">{{ (((quote &&
                                            quote.total) || 0) +
                                            9).toFixed(2) }}</label>
                                        <label style="font-size:40px;color:black;">{{ (company && company.currency) ||
                                            '€' }}</label>
                                        <label style="font-size:80px;color:black;font-weight:600;">{{ (quote &&
                                            quote.total) || 0 }}</label>
                                    </div>
                                </div>
                                <div style="font-size:18px;color:#7C7C7C;text-align:center;">per person</div>
                                <br>
                                <div v-if="frontend_url && quote && quote.id"
                                    style="text-align:center;margin-top:10px;margin-bottom:20px;">
                                    <a :href="`${frontend_url}/organiser_deposit/${quote.id}`"
                                        style="display:inline-block;background-color:#FAAF3A;color:#000000;font-family:Manrope,Arial,sans-serif;font-size:22px;font-weight:800;text-decoration:none;padding:18px 48px;border-radius:12px;letter-spacing:0.5px;">
                                        💳 Pay Your Deposit Now
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div style="background-color:#FAFAFA;padding:20px;">
                            <div style="max-width:700px;margin:0 auto;">
                                <!-- Accommodation Section -->
                                <div v-if="accommodationBuilds.length > 0">
                                    <div style="color:#FAAF3A;font-size:26px;font-weight:800;margin-bottom:20px;">
                                        Accommodation</div>
                                    <div v-for="(accom, index) in accommodationBuilds" :key="'accom-' + index"
                                        style="margin-bottom:30px;">
                                        <img v-if="getAccomImage(accom)"
                                            style="width:100%;height:250px;object-fit:cover;margin-bottom:15px;display:block;"
                                            :src="`http://api.gogroupbooking.com/media/suppliers/images/${getAccomImage(accom)}`">
                                        <div v-if="show_names"
                                            style="font-size:20px;color:#101010;font-weight:700;margin-bottom:10px;">
                                            {{ getAccomName(accom) }}
                                        </div>
                                        <div v-if="accom.start_date"
                                            style="font-size:13px;color:#3988AA;font-weight:600;margin-bottom:10px;">
                                            DATE — {{ $date(accom.start_date).format('dddd, Do MMMM YYYY') }}
                                        </div>
                                        <div v-if="show_descriptions && getAccomDescription(accom)"
                                            style="font-size:12px;color:#7C7C7C;font-weight:400;"
                                            v-html="getAccomDescription(accom)">
                                        </div>
                                    </div>
                                </div>

                                <!-- Activities Section -->
                                <div v-if="activityBuilds.length > 0">
                                    <div style="color:#FAAF3A;font-size:26px;font-weight:800;margin-bottom:20px;">
                                        Activities</div>
                                    <div v-for="(activity, index) in activityBuilds" :key="'activity-' + index"
                                        style="margin-bottom:20px;">
                                        <img v-if="getActivityImage(activity)"
                                            style="width:100%;height:250px;object-fit:cover;margin-bottom:10px;display:block;"
                                            :src="`http://api.gogroupbooking.com/media/suppliers/images/${getActivityImage(activity)}`">
                                        <div v-if="show_names"
                                            style="font-size:20px;color:#101010;font-weight:700;margin-bottom:10px;">
                                            {{ getActivityName(activity) }}
                                        </div>
                                        <div v-if="activity.start_date"
                                            style="font-size:13px;color:#3988AA;font-weight:600;margin-bottom:10px;">
                                            DATE — {{ $date(activity.start_date).format('dddd, Do MMMM YYYY') }}
                                        </div>
                                        <div v-if="show_descriptions && getActivityDescription(activity)"
                                            style="font-size:12px;color:#7C7C7C;font-weight:400;"
                                            v-html="getActivityDescription(activity)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 3 Reasons Section -->
                        <div
                            style="background-color:#000001;background-image:url('https://storage.googleapis.com/gogroupbooking/background_pattern.png');background-repeat:repeat;padding:20px 10px;">
                            <div
                                style="background-color:#FFFFFE;border:solid 1px #101010;border-radius:10px;margin-top:40px;margin-bottom:50px;">
                                <div
                                    style="background-color:#101010;color:#FAAF3A;font-size:16px;font-weight:700;padding:10px 20px;border-radius:10px 10px 0px 0px;">
                                    3 REASONS TO BOOK WITH US THAT OUR COMPETITORS DON'T WANT YOU TO KNOW
                                </div>
                                <div style="background-color:#FFFFFE;padding:40px;">
                                    <div>When you book through us, we give you the following benefits to make life
                                        easier on you.</div>
                                    <div>
                                        <ol>
                                            <li><b>No Stress.</b> With our online system, everybody pays online — No
                                                money chasing!</li>
                                            <li><b>You're In Control.</b> With our group system you handle Invites,
                                                Itinerary at the click of a button.</li>
                                            <li><b>Price Matching.</b> Find this package cheaper elsewhere, we'll beat
                                                it hands down!</li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                            <div
                                style="background-color:#FFFFFE;border:solid 1px #101010;border-radius:10px;margin-top:40px;margin-bottom:50px;">
                                <div
                                    style="background-color:#101010;color:#FAAF3A;font-size:16px;font-weight:700;padding:10px 20px;border-radius:10px 10px 0px 0px;">
                                    TO BOOK NOW, ONLY PAY ONE PERSON DEPOSIT
                                </div>
                                <div style="background-color:#FFFFFE;padding:40px;">
                                    <p>
                                        <b style="color:#AA3939;">
                                            BOOKING WITHIN 7 DAYS WILL GUARANTEE BEST PRICE. AVOID DISAPPOINTMENT.
                                            <br>
                                            So what are you waiting for? Call our talented event managers now on {{
                                                (company && company.number) || '' }}
                                        </b>
                                        <br><br>
                                        Book this week with a one off deposit to reserve the package for your maximum
                                        group size. All you need is the organisers payment as the deposit and the
                                        attendees have 3 weeks to secure their place with just a {{ currency }}50 deposit.
                                        <br><br>
                                        Simply follow the link in the quote above to pay the initial deposit or give us
                                        a call us now to get it all sorted over the phone!
                                        <br><br>
                                        You don't need to worry about collecting money or paying upfront, as it all can
                                        be done online with our easy online payment system.
                                        <br>
                                        Finally the balance won't be due for the rest of your group until {{ balanceDue }} before
                                        you go!
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- Footer Section -->
                        <div style="background-color:#000001;padding:20px 50px;">
                            <div style="display:flex;">
                                <div style="color:#FAAF3A;margin-right:20px;">STAG PARTY</div>
                                <div style="color:white;">|</div>
                                <div style="color:#FAAF3A;margin-left:20px;">HEN PARTY</div>
                            </div>
                        </div>
                        <div style="background-color:#000001;padding:20px 50px;">
                            <div style="display:flex;flex-wrap:wrap;">
                                <div style="flex:1;min-width:300px;margin-bottom:10px;">
                                    <div style="margin-bottom:10px;color:white;">© Copyright 2026 by {{
                                        brand.company_name || 'Company' }}. All Rights Reserved.</div>
                                    <div style="color:white;">
                                        <a :href="brand.website || '#'" style="color:#FAAF3A;">{{
                                            brand.website || '' }}</a>
                                        | Tel: <b style="color:#FAAF3A;">{{ (company && company.number) || '' }}</b>
                                    </div>
                                </div>
                                <div style="flex:1;min-width:300px;text-align:right;">
                                    <div>
                                        <a v-if="brand.terms_url" :href="brand.terms_url"
                                            style="color:#FAAF3A;">Terms and Conditions</a>
                                        <div style="color:white;">Online Payment Powered by gogroupbooking.com</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
            <v-divider />
            <v-card-text style="min-height:80px;padding-top:10px;">
                <v-row align="center" no-gutters dense>
                    <v-col cols="6">
                        <v-text-field :value="previewUrl" label="Preview URL" readonly outlined dense hide-details
                            append-icon="mdi-content-copy" @click:append="copyPreviewUrl"></v-text-field>
                    </v-col>
                    <v-col cols="3" class="pl-4">
                        <v-checkbox v-model="show_names" label="Send with Supplier Names" hide-details
                            dense></v-checkbox>
                    </v-col>
                    <v-col cols="3" class="pl-4">
                        <v-checkbox v-model="show_descriptions" label="Send with Supplier Descriptions" hide-details
                            dense></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn depressed @click="closeDialog()">
                    <v-icon small left>mdi-close</v-icon>
                    Cancel
                </v-btn>
                <v-btn depressed :dark="!sending" color="#3988AA" @click="sendQuote()" :disabled="sending || sendingSms || sendingWhatsApp"
                    :loading="sending">
                    <v-icon small left>mdi-email</v-icon>
                    Send Quote via Email
                </v-btn>
                <v-btn depressed :dark="!sendingSms" color="#25D366" @click="sendQuoteViaSms()" :disabled="sending || sendingSms || sendingWhatsApp"
                    :loading="sendingSms">
                    <v-icon small left>mdi-message-text</v-icon>
                    Send Quote via SMS
                </v-btn>
                <v-btn depressed :dark="!sendingWhatsApp" color="#128C7E" @click="sendQuoteViaWhatsApp()" :disabled="sending || sendingSms || sendingWhatsApp"
                    :loading="sendingWhatsApp">
                    <v-icon small left>mdi-whatsapp</v-icon>
                    Send Quote via WhatsApp
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { brandFor } from '@/utils/brand'
import { currencyFor, balanceDueLabel } from '@/utils/paymentTerms'

// Matches the quote builder's wizard step order (CustomQuote.vue's build_index_supplier_types)
// so same-day services appear in the same order the customer built them in.
const BUILD_TYPE_ORDER = [1, 2, 6, 8, 4, 5, 3, 7]

export default {
    props: {
        preview_dialog: {
            type: Boolean,
            default: false
        },
        quote: {
            type: Object,
            default: () => ({ builds: [] })
        },
        lead: {
            type: Object,
            default: () => ({ advisor: null })
        },
        company: {
            type: Object,
            default: () => ({ currency: '€' })
        }
    },
    data: () => ({
        show_descriptions: true,
        show_names: true,
        frontend_url: null,
        sending: false,
        sendingSms: false,
        sendingWhatsApp: false,
        customMessage: '',
        lastSavedMessage: null,
        saveMessageTimer: null,
    }),
    computed: {
        // Event type branding (Hen Party → Henit), else the company's
        brand() {
            return brandFor(this.company, this.lead && this.lead.event_type)
        },
        currency() {
            return currencyFor(this.company)
        },
        // "4 weeks" for Stagit, "6 weeks" for Freedom (the company's Cutoff For Payment)
        balanceDue() {
            return balanceDueLabel(this.company)
        },
        defaultMessage() {
            const advisorName = (this.lead && this.lead.advisor && this.lead.advisor.name) || 'Your advisor'
            const companyName = this.brand.company_name || 'us'
            const companyNumber = (this.company && this.company.number) || ''
            return `${advisorName} here.\n\nThanks for getting in contact with ${companyName}.\nYou are in safe hands with me.\n\nI have read over your details and I have put together a great package for you and your friends. I'll give you a quick call shortly to get the ball rolling.\n\nIf you have any questions, please pop me back an email or call me on ${companyNumber}.`
        },
        dialog: {
            get() {
                return this.preview_dialog
            },
            set(val) {
                if (!val) this.closeDialog()
            }
        },
        hasRequiredData() {
            return this.quote && this.lead && this.company
        },
        previewUrl() {
            if (!this.lead || !this.quote || !this.company) return ''
            const base = (process.env.VUE_APP_API_URL || '').replace(/\/$/, '')
            const showNames = this.show_names ? 1 : 0
            const showDescriptions = this.show_descriptions ? 1 : 0
            return `${base}/client/non_auth/quote/view/${this.lead.id}/${this.quote.id}/${this.company.id}/${showNames}/${showDescriptions}`
        },
        accommodationBuilds() {
            if (!this.quote || !this.quote.builds || !Array.isArray(this.quote.builds)) return []
            return this.quote.builds.filter(b => {
                try {
                    return !!(b && b.type_id === 1)
                } catch (e) {
                    return false
                }
            })
        },
        activityBuilds() {
            if (!this.quote || !this.quote.builds || !Array.isArray(this.quote.builds)) return []
            return this.quote.builds.filter(b => {
                try {
                    return !!(b && b.type_id !== 1)
                } catch (e) {
                    return false
                }
            }).slice().sort((a, b) => {
                const a_date = a.start_date || ''
                const b_date = b.start_date || ''
                if (a_date !== b_date) return a_date < b_date ? -1 : 1
                return BUILD_TYPE_ORDER.indexOf(a.type_id) - BUILD_TYPE_ORDER.indexOf(b.type_id)
            })
        }
    },
    watch: {
        preview_dialog(newVal) {
            if (newVal) {
                // Reset checkboxes when dialog opens
                this.show_descriptions = true
                this.show_names = true
                this.sending = false
                this.sendingSms = false
                this.sendingWhatsApp = false
                this.customMessage = (this.quote && this.quote.custom_message) || this.defaultMessage
                this.lastSavedMessage = this.customMessage
                this.fetchPaymentSettings()
            } else {
                this.sending = false
                this.sendingSms = false
                this.sendingWhatsApp = false
                if (this.saveMessageTimer) {
                    clearTimeout(this.saveMessageTimer)
                    this.saveMessageTimer = null
                }
            }
        }
    },
    methods: {
        closeDialog() {
            this.saveCustomMessage()
            this.$emit('closePreviewDialog')
        },
        onCustomMessageChange() {
            if (this.saveMessageTimer) clearTimeout(this.saveMessageTimer)
            this.saveMessageTimer = setTimeout(() => {
                this.saveCustomMessage()
            }, 800)
        },
        async saveCustomMessage() {
            if (this.saveMessageTimer) {
                clearTimeout(this.saveMessageTimer)
                this.saveMessageTimer = null
            }
            if (!this.quote || !this.quote.id) return
            if (this.customMessage === this.lastSavedMessage) return
            const messageToSave = this.customMessage
            try {
                await this.$axios.post(`admin/quotes/update_quote_custom_message/${this.quote.id}`, {
                    custom_message: messageToSave
                })
                this.lastSavedMessage = messageToSave
            } catch (error) {
                console.error('Failed to save custom message:', error)
            }
        },
        async sendQuote() {
            this.sending = true
            await this.saveCustomMessage()
            this.$emit('sendQuote', {
                show_descriptions: this.show_descriptions,
                show_names: this.show_names
            })
        },
        async sendQuoteViaSms() {
            this.sendingSms = true
            await this.saveCustomMessage()
            this.$emit('sendQuoteViaSms')
        },
        async sendQuoteViaWhatsApp() {
            this.sendingWhatsApp = true
            await this.saveCustomMessage()
            this.$emit('sendQuoteViaWhatsApp')
        },
        getAccomImage(build) {
            if (!build) return null
            return build.supplier?.image || build.supplier?.products?.[0]?.image || null
        },
        getAccomName(build) {
            if (!build) return 'Accommodation'
            let name = build.option?.name || build.supplier?.products?.[0]?.name || 'Accommodation'
            // Only tier names ("3 Star", "Luxury") get " Hotel"; apartments, houses etc. keep their own name (matches quote.blade.php)
            if (name && !/hotel|apart|house|hostel|accommodation|residence|suite|room|bed|villa|lodge|cottage|stay/i.test(name)) {
                name += ' Hotel'
            }
            return name
        },
        getAccomDescription(build) {
            if (!build) return null
            return build.supplier?.description || build.option?.description || build.supplier?.products?.[0]?.description || null
        },
        getActivityImage(build) {
            if (!build) return null
            return build.option?.image || build.option?.product_type?.image || build.supplier?.image || null
        },
        getActivityName(build) {
            if (!build) return 'Activity'
            return build.option?.name || build.supplier?.products?.[0]?.name || 'Activity'
        },
        getActivityDescription(build) {
            if (!build) return null
            return build.supplier?.description || build.option?.description || build.supplier?.products?.[0]?.description || null
        },
        copyPreviewUrl() {
            if (this.previewUrl) {
                navigator.clipboard.writeText(this.previewUrl)
                this.$toast.success('Preview URL copied to clipboard!')
            }
        },
        async fetchPaymentSettings() {
            if (!this.company || !this.company.id) return
            try {
                const response = await this.$axios.get(`admin/company_settings/get_payment_settings/${this.company.id}`)
                if (response.data && response.data.response && response.data.data) {
                    this.frontend_url = response.data.data.frontend_url ? response.data.data.frontend_url.replace(/\/$/, '') : null
                }
            } catch (error) {
                // Silent fail - button just won't show
                console.error('Failed to fetch payment settings:', error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.card-section-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.card-section-title {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 700;
    color: white;
}

.email-preview-container {
    background-color: #f5f5f5;
    padding: 20px;
}

.email-content {
    background-color: white;
    max-width: 800px;
    margin: 0 auto;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.first-paragraph {
    background-color: #FFFFFE;
    padding: 50px;
}
</style>
